(function () {
  const STORAGE_KEY = "thegoldencascade_wishlist";

  /* ---------------- MEMORY CACHE ---------------- */
  let wishlistCache = null;

  function getWishlist() {
    if (wishlistCache !== null) return wishlistCache;
    try {
      wishlistCache = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      wishlistCache = [];
    }
    return wishlistCache;
  }

  function saveWishlist(data) {
    wishlistCache = data;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }

  /* ---------------- HEADER ---------------- */
  function updateHeader() {
    const items = getWishlist();
    const counter = document.querySelector(".wishlist-counter");
    const icon = document.querySelector(".header-wishlist-icon");

    if (counter) counter.textContent = items.length;
    if (icon) icon.classList.toggle("active", items.length > 0);
  }

  /* ---------------- BUTTON STATE (NO FULL DOM SCAN) ---------------- */
  function updateButtonState(button) {
    const wishlist = getWishlist();
    const handle = button.dataset.wishlistHandle;
    button.classList.toggle("active", wishlist.includes(handle));
  }

  function updateVisibleButtons(root = document) {
    root.querySelectorAll("[data-wishlist-handle]").forEach(updateButtonState);
  }

  /* ---------------- ADD / REMOVE ---------------- */
  function addItem(handle) {
    const wishlist = getWishlist();
    if (wishlist.includes(handle)) return;

    wishlist.push(handle);
    saveWishlist(wishlist);

    updateHeader();
    updateVisibleButtons();
  }

  function removeItem(handle) {
    let wishlist = getWishlist().filter((item) => item !== handle);
    saveWishlist(wishlist);

    const card = document.querySelector(
      `.product-card[data-handle="${handle}"]`,
    );
    if (card) card.remove();

    updateHeader();
    updateVisibleButtons();
    toggleEmpty();
  }

  function toggleItem(handle) {
    const wishlist = getWishlist();
    if (wishlist.includes(handle)) removeItem(handle);
    else addItem(handle);
  }

  /* ---------------- WISHLIST PAGE (SEQUENTIAL LOAD = FAST) ---------------- */
  async function renderWishlistPage() {
    const container = document.getElementById("wishlist-container");
    const empty = document.getElementById("wishlist-empty-message");
    if (!container) return;

    const wishlist = getWishlist();
    container.innerHTML = "";

    if (!wishlist.length) {
      if (empty) empty.style.display = "block";
      return;
    }

    if (empty) empty.style.display = "none";

    for (const handle of wishlist) {
      try {
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();
        container.appendChild(createCard(product));
      } catch (e) {
        console.warn("Wishlist product failed:", handle);
      }
    }
  }

  function createCard(product) {
    const card = document.createElement("div");

    /*
     * IMPORTANT:
     * Keep these existing hooks.
     * removeItem() depends on them.
     */
    card.className = "product-card wishlist-product-card";
    card.dataset.handle = product.handle;

    card.innerHTML = `
    <div class="wishlist-product-card__image-wrap">

      <a
        href="/products/${product.handle}"
        class="wishlist-product-card__image"
        aria-label="${product.title}"
      >
        <img
          src="${product.images[0]}"
          alt="${product.title}"
          loading="lazy"
        >
      </a>

      <button
        type="button"
        class="wishlist-product-card__remove remove-from-wishlist"
        data-handle="${product.handle}"
        aria-label="Remove ${product.title} from wishlist"
      >
        ×
      </button>

    </div>

    <div class="wishlist-product-card__details">

      <div class="wishlist-product-card__main">

        <a
          href="/products/${product.handle}"
          class="wishlist-product-card__title"
        >
          ${product.title}
        </a>

        <div class="wishlist-product-card__price">
          ₹${(product.price / 100).toFixed(2)}
        </div>

      </div>

      <div class="wishlist-product-card__bottom">

        <a
          href="/products/${product.handle}"
          class="wishlist-product-card__view"
        >
          View Product
          <span aria-hidden="true">→</span>
        </a>

        <span
          class="wishlist-product-card__saved"
          aria-hidden="true"
        >
          ♡
        </span>

      </div>

    </div>
  `;

    /*
     * EXISTING REMOVE FUNCTIONALITY
     * DO NOT CHANGE
     */
    card
      .querySelector(".remove-from-wishlist")
      .addEventListener("click", (e) => {
        e.preventDefault();
        removeItem(product.handle);
      });

    return card;
  }

  ///start new funtion
  function toggleEmpty() {
    const container = document.getElementById("wishlist-container");
    const empty = document.getElementById("wishlist-empty-message");
    if (!container || !empty) return;
    empty.style.display = container.children.length ? "none" : "block";
  }

  /* ---------------- EVENT DELEGATION ---------------- */
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wishlist-handle]");
    if (!btn) return;

    e.preventDefault();
    toggleItem(btn.dataset.wishlistHandle);
    updateButtonState(btn);
  });

  /* ---------------- DAWN SECTION COMPATIBILITY ---------------- */
  document.addEventListener("DOMContentLoaded", () => {
    updateHeader();
    updateVisibleButtons();
    renderWishlistPage();
  });

  document.addEventListener("shopify:section:load", (e) => {
    updateVisibleButtons(e.target);
    updateHeader();
  });
})();
